import { d } from "./index-Dvb-FM3N.js";
import { l as y } from "./index-CERo1xtz.js";
import { n as h, u as l } from "./utils-CTvTB86_.js";
const k = (n, e, r) => {
  const c = d.ChunkHeader.create({
    extraEntropy: n,
    untrustedChunkContentSizes: r,
    untrustedContentSize: e
  });
  return d.ChunkHeader.encodeDelimited(c).finish();
}, m = () => {
  const n = d.VersionHeader.create({
    version: 0
  });
  return d.VersionHeader.encodeDelimited(n).finish();
}, C = (n, e, r, c, t, s) => {
  const a = k(
    e,
    t,
    s
  ), o = new Uint8Array([...c, ...a, ...r]), i = y.md.sha256.create();
  i.update(l(o));
  const u = y.util.binary.raw.decode(i.digest().bytes()), p = new f(n).encrypt(o);
  return [u, p];
};
function b(n, e) {
  const r = Math.ceil(n.byteLength / e), c = [];
  for (let t = 0; t < r; t++) {
    const s = n.slice(t * e, t * e + e), a = m(), o = k(h.randomBytes(16), null, null), i = new Uint8Array([
      ...a,
      ...o
    ]), u = new Uint8Array([...i, ...s]), H = y.md.sha256.create();
    H.update(l(u));
    const p = y.util.binary.raw.decode(
      H.digest().bytes()
    );
    c.push({
      contentSize: s.length,
      contentWithHeaders: u,
      hash: p
    });
  }
  return c;
}
function D(n) {
  const e = m();
  return new TransformStream({
    transform({ data: r, progress: c }, t) {
      const s = (/* @__PURE__ */ new Date()).getTime(), [a, o] = C(
        n,
        h.randomBytes(16),
        r,
        e,
        null,
        null
      );
      t.enqueue({
        data: {
          chunkHash: a,
          encryptedChunk: o
        },
        progress: c
      });
      const i = (/* @__PURE__ */ new Date()).getTime();
      console.info(`[client] Encryption took ${i - s} ms`);
    }
  });
}
class f {
  encKey;
  constructor(e) {
    this.encKey = e;
  }
  encrypt(e) {
    const r = h.randomBytes(h.secretbox.nonceLength), c = h.secretbox(e, r, this.encKey), t = d.EncryptionHeader.create({
      chilyKey: {
        encryptionNonce: r
      }
    }), s = d.EncryptionHeader.encodeDelimited(
      t
    ).finish();
    return new Uint8Array([
      ...s,
      ...c
    ]);
  }
}
export {
  f as StorageCipher,
  b as createChunks,
  C as createEncryptedChunk,
  D as createEncryptedChunks,
  m as createVersionHeader
};
//# sourceMappingURL=storage.js.map
